import api from "@/plugins/api";
import { mapApiContactRelations, } from "../mappers/mapApiContactRelations";
export async function getContactRelations(contactId) {
    // `unwrapEnvelope`: the response interceptor strips the ApiResponse envelope.
    const response = await api.get(`/contacts/${contactId}/relations`, {
        unwrapEnvelope: true,
    });
    return mapApiContactRelations(response.data);
}
export async function createContactRelation(contactId, payload) {
    await api.post(`/contacts/${contactId}/relations`, payload, { unwrapEnvelope: true });
}
/** Creates a contact↔organisation relation only when none exists for that organisation. */
export async function autoCreateOrganisationRelation(contactId, organisationId) {
    const existing = await getContactRelations(contactId);
    const hasRelation = existing.organisations.some((rel) => rel.id === organisationId);
    if (hasRelation)
        return;
    const d = new Date();
    const startDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    await createContactRelation(contactId, {
        organisationId,
        functions: [{ title: null, function: "not_specified", startDate, endDate: null }],
    });
}
// GET /contacts/{contactId}/organisation-relations/{orgId}/delete-preview
// Returns org name + coordinates (channels + address links) that will be cascade-deleted with the relation.
export async function getRelationDeletePreview(contactId, orgId) {
    const response = await api.get(`/contacts/${contactId}/organisation-relations/${orgId}/delete-preview`, {
        unwrapEnvelope: true,
    });
    return {
        organisationName: response.data.organisationName,
        coordinates: response.data.coordinates.map((c) => ({
            id: c.id,
            kind: c.kind,
            type: c.type,
            value: c.value,
            context: c.context,
            isPrimary: c.isPrimary,
        })),
    };
}
// PUT /contacts/{contactId}/organisation-relations/{orgId}/functions
// Reconciles the full function list in one call: upserts modified/new rows, deletes removed rows.
export async function setRelationFunctions(contactId, orgId, payload) {
    await api.put(`/contacts/${contactId}/organisation-relations/${orgId}/functions`, payload, { unwrapEnvelope: true });
}
// DELETE /contacts/{contactId}/organisation-relations/{orgId}
// Cascades deletion of all functions and org-anchored coordinates/addresses (204 no body)
export async function deleteContactRelation(contactId, orgId) {
    await api.delete(`/contacts/${contactId}/organisation-relations/${orgId}`, { unwrapEnvelope: true });
}
